// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__tV1D_","pagination__bullet":"Pagination_pagination__bullet__NZ3mY","pagination__bullet--active":"Pagination_pagination__bullet--active___0mX9"};